module.exports = __webpack_public_path__ + "Hotels.png?d290c32f644052e634e5ce8198735e73";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/Hotels.png
// module id = 452
// module chunks = 0